// Starts before the bootstrap chunk so it overlaps MF share-scope init and bundle evaluation.
const assetPrefix = process.env.APPSHELL_ASSET_PREFIX.replace(/\/$/, '')
const envUrl = `${assetPrefix}/config/env.json`
const envPromise = fetch(envUrl, { cache: 'no-store' }).then((response) => {
  if (!response.ok) {
    throw new Error(`Failed to fetch ${envUrl}: ${response.status}`)
  }
  return response.json()
})

import('./bootstrap').then(({ start }) => start(envPromise))
